import { useQuery } from '@tanstack/react-query';
import { queryFetch } from '@services/api';
import { ApiError } from '@root/globalTypes';
import { queryKeys } from '@utils/consts';
import { useQueryParams } from '@hooks/queryParams';
import { EquipmentDropdownProps, EquipmentRespSuccess } from './types';
import { useAppContext } from '@contexts/app';

export const useEquipmentDropdown = ({ divisionIds }: EquipmentDropdownProps = {}) => {
  const { isDropdownEnabled: enabled } = useAppContext();
  const { parseParams } = useQueryParams();

  const queryParams = parseParams({ divisionIds }, { arrayFormat: 'bracket' });

  const { data, error, isPending } = useQuery<EquipmentRespSuccess, ApiError>({
    queryKey: [...queryKeys.dropdowns.equipment, queryParams],
    queryFn: () => queryFetch({ url: `dropdowns/assets${queryParams}` }),
    enabled,
    placeholderData: (previousData) => previousData as EquipmentRespSuccess,
    retry: 2,
  });

  return {
    data,
    error,
    isLoading: isPending && enabled,
  };
};
